import { useState } from "react";

const STORAGE_KEY = "domera-guest-lang";

// Every string a guest sees, in both languages (spec K5). Menu item names are
// the hotel's own and are not translated.
// The reasons staff can pick with one tap (next/RejectOrderDialog.jsx). One of
// these exactly is shown in the guest's language; anything else is staff's own
// words and is shown as written.
export const PRESET_KEYS = ["reject.preset.notOrdered", "reject.preset.outOfStock", "reject.preset.kitchenClosed"];

export function rejectionReason(reason, t) {
  const key = PRESET_KEYS.find((candidate) => TEXT.tr[candidate] === reason);
  return key ? t(key) : reason;
}

export const TEXT = {
  tr: {
    "hotel.fallback": "Otel",
    "lang.label": "Dili değiştir",
    loading: "Yükleniyor…",
    retry: "Tekrar dene",
    "error.signature": "Bu QR kod geçersiz. Lütfen personele başvurun.",
    "error.network": "Sunucuya ulaşılamadı. İnternet bağlantınızı kontrol edip tekrar deneyin.",
    "error.generic": "Bir sorun oluştu, lütfen tekrar deneyin.",
    "error.rateLimited": "Çok fazla istek gönderildi. Lütfen birkaç dakika sonra tekrar deneyin.",
    "error.noStay": "Şu an oda servisi siparişi alınamıyor. Lütfen resepsiyonu arayın.",
    "error.featureOff": "Bu otelde QR ile sipariş kapalı.",
    "error.itemUnavailable": "Seçtiğiniz ürünlerden biri artık sunulmuyor. Sepetinizi kontrol edin.",
    "category.all": "Tümü",
    "category.soup": "Çorbalar",
    "category.appetizer": "Başlangıçlar",
    "category.main": "Ana yemekler",
    "category.dessert": "Tatlılar",
    "category.beverage": "İçecekler",
    "menu.empty": "Menüde şu an ürün yok.",
    "menu.add": "{name} ekle",
    "cart.summary": "{count} ürün · {total}",
    "cart.summary.one": "{count} ürün · {total}",
    "cart.open": "Sepeti gör",
    "cart.title": "Sepetiniz",
    "cart.increase": "{name} adedini artır",
    "cart.decrease": "{name} adedini azalt",
    "cart.send": "Siparişi gönder",
    "cart.sending": "Gönderiliyor…",
    "cart.close": "Kapat",
    "cart.roomNote": "Tutar oda hesabınıza yazılır.",
    "table.readOnly": "Siparişinizi garsonunuza verebilirsiniz.",
    "order.sent": "Siparişiniz mutfağa gönderildi.",
    "order.title": "Siparişiniz",
    "order.total": "Toplam",
    "order.payWaiter": "Ödemeyi garsonunuza yapabilirsiniz.",
    "order.rejected": "Reddedildi: {reason}",
    "reject.preset.notOrdered": "Misafir sipariş vermediğini söyledi",
    "reject.preset.outOfStock": "Ürün kalmadı",
    "reject.preset.kitchenClosed": "Mutfak kapalı",
    "status.awaiting_approval": "Onay bekliyor",
    "status.pending": "Alındı",
    "status.preparing": "Hazırlanıyor",
    "status.served": "Servis edildi",
    "room.title": "Oda {number}",
    "tab.concierge": "Konsiyerj",
    "tab.requests": "Talepler",
    "tab.roomService": "Oda servisi",
    "concierge.greeting": "Merhaba! Ben {hotel} konsiyerj asistanıyım. WiFi, kahvaltı, havuz, SPA, çıkış saati ya da çevredeki yerler hakkında sorabilirsiniz.",
    "concierge.placeholder": "Sorunuzu yazın…",
    "concierge.send": "Gönder",
    "concierge.thinking": "Yazıyor…",
    "concierge.unavailable": "Şu anda yanıt veremiyorum. Lütfen resepsiyona başvurun.",
    "quick.wifi": "WiFi şifresi",
    "quick.wifi.q": "WiFi şifresi nedir?",
    "quick.breakfast": "Kahvaltı saatleri",
    "quick.breakfast.q": "Kahvaltı saat kaçta?",
    "quick.pool": "Havuz saatleri",
    "quick.pool.q": "Havuz saat kaçta açık?",
    "quick.spa": "SPA ve hamam",
    "quick.spa.q": "SPA ve hamam saatleri nedir?",
    "quick.checkout": "Çıkış saati",
    "quick.checkout.q": "Çıkış saati nedir?",
    "quick.nearby": "Gezi ve yemek",
    "quick.nearby.q": "Çevrede gezilecek yerler neler?",
    "requests.title": "Ne istersiniz?",
    "request.towels": "Ekstra havlu",
    "request.water": "Su",
    "request.cleaning": "Oda temizliği",
    "request.toiletries": "Buklet seti",
    "request.maintenance": "Teknik arıza",
    "requests.notes": "Not (isteğe bağlı)",
    "requests.photo": "Fotoğraf ekle",
    "requests.photoRemove": "Fotoğrafı kaldır",
    "requests.send": "Talebi gönder",
    "requests.sent": "Talebiniz iletildi.",
    "requests.open": "Açık talepler",
    "requests.none": "Açık talebiniz yok.",
    "requestStatus.pending": "Alındı",
    "requestStatus.in_progress": "İletildi",
    "requestStatus.completed": "Hazır",
    "rating.title": "Nasıldı?",
    "rating.star": "{n} yıldız",
    "rating.star.one": "{n} yıldız",
    "rating.comment": "Yorum (isteğe bağlı)",
    "rating.send": "Puanı gönder",
    "rating.thanks": "Teşekkür ederiz!",
    "rating.pick": "Lütfen yıldız seçin.",
    "rs.myOrders": "Siparişlerim",
    "rs.sent": "Siparişiniz alındı. Personel onaylayınca hazırlanacak.",
    "boot.crashTitle": "Beklenmedik bir hata oluştu",
    "boot.crashBody": "Sorun bildirildi. Lütfen sayfayı yenileyin.",
    "boot.reload": "Sayfayı yenile",
    "boot.loadFailed": "Sayfa yüklenemedi. Bağlantınızı kontrol edip tekrar deneyin.",
  },
  en: {
    "hotel.fallback": "Hotel",
    "lang.label": "Change language",
    loading: "Loading…",
    retry: "Try again",
    "error.signature": "This QR code is not valid. Please ask a member of staff.",
    "error.network": "Could not reach the server. Check your connection and try again.",
    "error.generic": "Something went wrong, please try again.",
    "error.rateLimited": "Too many requests. Please try again in a few minutes.",
    "error.noStay": "Room service cannot take orders right now. Please call reception.",
    "error.featureOff": "Ordering by QR is not available at this hotel.",
    "error.itemUnavailable": "One of the items is no longer available. Please check your basket.",
    "category.all": "All",
    "category.soup": "Soups",
    "category.appetizer": "Starters",
    "category.main": "Mains",
    "category.dessert": "Desserts",
    "category.beverage": "Drinks",
    "menu.empty": "There is nothing on the menu right now.",
    "menu.add": "Add {name}",
    "cart.summary": "{count} items · {total}",
    "cart.summary.one": "1 item · {total}",
    "cart.open": "View basket",
    "cart.title": "Your basket",
    "cart.increase": "One more {name}",
    "cart.decrease": "One fewer {name}",
    "cart.send": "Send order",
    "cart.sending": "Sending…",
    "cart.close": "Close",
    "cart.roomNote": "The amount is added to your room bill.",
    "table.readOnly": "Please give your order to your waiter.",
    "order.sent": "Your order has been sent to the kitchen.",
    "order.title": "Your order",
    "order.total": "Total",
    "order.payWaiter": "Please pay your waiter.",
    "order.rejected": "Declined: {reason}",
    "reject.preset.notOrdered": "The guest said they did not place this order",
    "reject.preset.outOfStock": "Out of stock",
    "reject.preset.kitchenClosed": "The kitchen is closed",
    "status.awaiting_approval": "Waiting for confirmation",
    "status.pending": "Received",
    "status.preparing": "Being prepared",
    "status.served": "Served",
    "room.title": "Room {number}",
    "tab.concierge": "Concierge",
    "tab.requests": "Requests",
    "tab.roomService": "Room service",
    "concierge.greeting": "Hello! I'm the {hotel} concierge assistant. Ask me about WiFi, breakfast, the pool, the spa, check-out time or places nearby.",
    "concierge.placeholder": "Type your question…",
    "concierge.send": "Send",
    "concierge.thinking": "Typing…",
    "concierge.unavailable": "I can't answer right now. Please contact reception.",
    "quick.wifi": "WiFi password",
    "quick.wifi.q": "What is the WiFi password?",
    "quick.breakfast": "Breakfast hours",
    "quick.breakfast.q": "What time is breakfast?",
    "quick.pool": "Pool hours",
    "quick.pool.q": "When is the pool open?",
    "quick.spa": "Spa",
    "quick.spa.q": "What are the spa hours?",
    "quick.checkout": "Check-out time",
    "quick.checkout.q": "What time is check-out?",
    "quick.nearby": "Places nearby",
    "quick.nearby.q": "What are good places to visit and eat nearby?",
    "requests.title": "What do you need?",
    "request.towels": "Extra towels",
    "request.water": "Water",
    "request.cleaning": "Room cleaning",
    "request.toiletries": "Toiletries",
    "request.maintenance": "Something is broken",
    "requests.notes": "Note (optional)",
    "requests.photo": "Add a photo",
    "requests.photoRemove": "Remove photo",
    "requests.send": "Send request",
    "requests.sent": "Your request has been sent.",
    "requests.open": "Open requests",
    "requests.none": "You have no open requests.",
    "requestStatus.pending": "Received",
    "requestStatus.in_progress": "On its way",
    "requestStatus.completed": "Done",
    "rating.title": "How did we do?",
    "rating.star": "{n} stars",
    "rating.star.one": "1 star",
    "rating.comment": "Comment (optional)",
    "rating.send": "Send rating",
    "rating.thanks": "Thank you!",
    "rating.pick": "Please choose a star rating.",
    "rs.myOrders": "My orders",
    "rs.sent": "Order received. It will be prepared once staff confirm it.",
    "boot.crashTitle": "Something went wrong",
    "boot.crashBody": "The problem has been reported. Please reload the page.",
    "boot.reload": "Reload page",
    "boot.loadFailed": "The page could not load. Check your connection and try again.",
  },
};

function readStored() {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function initialLang(stored = readStored(), browserLanguage = (typeof navigator !== "undefined" && navigator.language) || "") {
  if (stored === "tr" || stored === "en") return stored;
  return browserLanguage.toLowerCase().indexOf("tr") === 0 ? "tr" : "en";
}

function fill(text, vars) {
  if (!vars) return text;
  return text.replace(/\{(\w+)\}/g, (match, name) => (name in vars ? String(vars[name]) : match));
}

export function useLang() {
  const [lang, setLangState] = useState(() => initialLang());
  const setLang = (next) => {
    setLangState(next);
    try {
      window.localStorage.setItem(STORAGE_KEY, next);
    } catch {
      // A phone that refuses storage keeps the choice for this visit only.
    }
  };
  const t = (key, vars) => fill(TEXT[lang][key] ?? TEXT.tr[key] ?? key, vars);
  return { lang, setLang, t };
}

// English needs "1 item" / "1 star": the singular lives under `<key>.one`.
export const pluralKey = (key, count) => (count === 1 ? `${key}.one` : key);

export function money(amount, lang) {
  return new Intl.NumberFormat(lang === "en" ? "en-GB" : "tr-TR", { style: "currency", currency: "TRY" }).format(Number(amount) || 0);
}
